/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Field_KindInputs */

const vi_stocktake_field_kind = /** @type {(inputs: Stocktake_Field_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại lô`)
};

/**

* @param {Stocktake_Field_KindInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_field_kind = /** @type {((inputs?: Stocktake_Field_KindInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Field_KindInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_field_kind(inputs)
});